import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Assignment as FormIcon } from '@mui/icons-material';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import {
  campaignLeadManagementAtom,
  leadsTableStateAtom,
} from '../../../Services/_states/index.js';
import { LeadFormActions } from '../../../Services/_actions/index.js';

const FormTabs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const actions = LeadFormActions();

  const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
    campaignLeadManagementAtom
  );
  const setTableState = useSetRecoilState(leadsTableStateAtom);

  const allForms =
    campaignLeadManagementData?.selectedCampaign?.proposal_id
      ? campaignLeadManagementData?.[
      campaignLeadManagementData?.selectedCampaign?.proposal_id
      ] || []
      : [];

  const selectedFormId =
    campaignLeadManagementData?.selectedForm?.leads_form_id ?? '';

  const handleChange = async (event, newFormId) => {
    const form = allForms.find((f) => f.leads_form_id === newFormId);
    if (!form) return;

    await getStatusList(form);

    const localData = {
      campaign: campaignLeadManagementData?.selectedCampaign,
      webForm: form,
    };
    localStorage.setItem('leadWebFormData', JSON.stringify(localData));
  };

  const getStatusList = async (form) => {
    if (!form?.leads_form_id) return;

    let statusList = [];
    try {
      const payload = {
        active: { value: true },
        leadFormId: form.leads_form_id,
      };
      if (
        campaignLeadManagementData?.statusData?.[form.leads_form_id]?.length > 0
      ) {
        statusList = campaignLeadManagementData?.statusData?.[form.leads_form_id];
      } else {
        const res = await actions.fetchStatusAndSubStatus(payload);
        if (res?.status === 200 && Array.isArray(res.data)) {
          statusList = res.data;
        }
      }
    } catch (error) {
      console.warn('Failed to fetch status list:', error);
    } finally {
      setTableState((prev) => ({
        // ...prev,
        data: [],
        totalCount: 0,
        uniquePhoneCount: 0,
        isCampaignOwner: false,
        filters: {
          search: '',
          limit: 100,
          offset: 0,
          status: '',
          start_date: '',
          end_date: '',
          sort_type: '',
          sort_by: '',
          dynamicFilters: {},
          campaign_id: campaignLeadManagementData?.selectedCampaign?.proposal_id,
          leads_form_id: form?.leads_form_id,
        },
      }));
      setCampaignLeadManagementData((prev) => ({
        ...prev,
        selectedForm: form,
        statusData: {
          ...(prev?.statusData || {}),
          [form.leads_form_id]: statusList,
        },
      }));
    }
  };

  return (
    <Box
      sx={{
        // mb: { sm: 2, xs: 1 },
        // backgroundColor: 'background.paper',
        // borderRadius: 2,
        // boxShadow: 1,
        p: 1,
      }}
    >
      <Tabs
        value={selectedFormId}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Lead Forms Tabs"
        sx={{
          minHeight: 40,
          '& .MuiTabs-flexContainer': {
            gap: 1,
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontSize: '0.85rem',
            minHeight: 36,
            borderRadius: 2,
            padding: '6px 12px',
            // backgroundColor: '#fff',
            // border: '1px solid #e0e0e0',
            transition: 'all 0.2s ease-in-out',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
            // '&.Mui-selected': {
            //   backgroundColor: theme.palette.primary.main,
            //   color: '#fff',
            //   border: 'none',
            //   boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            // },
          },
        }}
      >
        {allForms.map((form) => (
          <Tab
            key={form?.leads_form_id}
            value={form?.leads_form_id}
            icon={<FormIcon fontSize="small" />}
            iconPosition="start"
            label={
              <Typography variant="body2" fontWeight={500} noWrap>
                {isMobile
                  ? `${form?.leads_form_name?.substring(0, 10)}...`
                  : form?.leads_form_name}
              </Typography>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default FormTabs;
